function isKeyAnArray(filters, key) {
  return Array.isArray(filters[key]);
}

function isFilterFirst(index) {
  return index === 0;
}

function getFiltersFromArray(filters, key, index) {
  return filters[key].map((filter, order) => {
    if (filters[key]) {
      if (isFilterFirst(index) && isFilterFirst(order)) {
        return `${key}=${filter}`;
      }

      return `&${key}=${filter}`;
    }

    return '';
  }).join('');
}

function getSingleFilters(filters, key, index) {
  if (filters[key]) {
    if (isFilterFirst(index)) {
      return `${key}=${filters[key]}`;
    }

    return `&${key}=${filters[key]}`;
  }

  return '';
}

export default function getUrlFiltered(baseURL, filters) {
  let url;

  switch (filters) {
    default:
      url = `${baseURL}?${Object.keys(filters).map((key, index) => {
        if (isKeyAnArray(filters, key)) {
          return getFiltersFromArray(filters, key, index);
        }

        return getSingleFilters(filters, key, index);
      }).join('')}`;
      break;

    case undefined:
      url = baseURL;
      break;
  }
  return url;
}
